import { useMemo } from "react";
import { createContext, type PropsWithChildren } from "react";
import { CARS_HTS_EVENT_TRANSFORMER_HOOKS } from "@apac/cars";
import { HOTEL_CHECKOUT_HTS_EVENT_TRANSFORMER_HOOKS } from "@b2bportal/core-checkout";
import { CORE_FLIGHTS_HTS_EVENT_TRANSFORMER_HOOKS } from "@b2bportal/core-flights";
import { HOTEL_HTS_EVENT_TRANSFORMER_HOOKS } from "@b2bportal/core-hotels";
import {
  TrackingProvider,
  usePublishHTSEvent,
  createUseEmitRawEvent,
  mergeEventTransformerHooks,
} from "@b2bportal/core-tracking";
import { CORE_COMMON_HTS_EVENT_TRANSFORMER_HOOKS } from "@b2bportal/core-tracking";
import {
  initialAppTrackingProviderContext,
  useAppTrackingProvider,
} from "./useAppTrackingProvider";

export const AppTrackingContext = createContext<
  ReturnType<typeof useAppTrackingProvider>
>(initialAppTrackingProviderContext);

export const AppTrackingProvider = (props: PropsWithChildren<unknown>) => {
  const context = useAppTrackingProvider();

  const useEmitHTSEvent = createUseEmitRawEvent({
    transformerHooks: mergeEventTransformerHooks(
      CARS_HTS_EVENT_TRANSFORMER_HOOKS,
      CORE_COMMON_HTS_EVENT_TRANSFORMER_HOOKS,
      CORE_FLIGHTS_HTS_EVENT_TRANSFORMER_HOOKS,
      HOTEL_HTS_EVENT_TRANSFORMER_HOOKS,
      HOTEL_CHECKOUT_HTS_EVENT_TRANSFORMER_HOOKS
    ),
    usePublishEvent: usePublishHTSEvent,
  });

  const emitRawEventHooks = useMemo(() => [useEmitHTSEvent], []);

  return (
    <AppTrackingContext.Provider value={context}>
      <TrackingProvider emitRawEventHooks={emitRawEventHooks}>
        {props.children}
      </TrackingProvider>
    </AppTrackingContext.Provider>
  );
};
